import ReactJson from "react-json-view";
import { useInfiniteQuery, useMutation } from "@tanstack/react-query";
import { useInView } from "react-intersection-observer";
import { fetchAllTickets, fetchUpdateAssingTo, fetchupdateToKanbanBoard } from "../../utils/apiUtils";
import SharedTable from "../benefitPlan/SharedTable";
import { useCallback, useEffect, useState } from "react";
import debounce from "lodash.debounce";
import { queryClient } from "../../App";

const Backlog = () => {

    const [searchValue, setSearchValue] = useState();
    const [decouncedSearchValue, setDecouncedSearchValue] = useState('');
    const [lastUpdatedAt, setLastUpdatedAt] = useState()
    const { ref, inView } = useInView();

    const queryKey = ['backlog', decouncedSearchValue];

    const {
        data,
        refetch,
        fetchNextPage,
        fetchPreviousPage,
        isLoading, //first time only
        isFetching,

        hasNextPage,
        isFetched,
        hasPreviousPage,
        isFetchingNextPage,
        isFetchingPreviousPage,
        isError,
        status,
        error
    } = useInfiniteQuery({
        retry: false,
        refetchOnWindowFocus: true,
        queryKey,
        queryFn: ({ pageParam }) => {
            let params = { lastEvaluatedKey: pageParam };

            if (decouncedSearchValue) {
                params.ticketPrefix = decouncedSearchValue
            }

            return fetchAllTickets(params)
        },
        select: (data) => {
            return {
                pages: data.pages.map((page) => page.Items).flatMap((x) => x),
                pageParams: data.pageParams,
            };
            // return { ...data.hits, timestamp: Date.now() }
        },
        getNextPageParam: (lastPage, allPages) => {
            return lastPage.LastEvaluatedKey ? encodeURIComponent(JSON.stringify(lastPage.LastEvaluatedKey)) : null
        },

        staleTime: 0,//,Infinity,
        enabled: true  //&& !!showChat
    })

    useEffect(() => {
        if (inView) {
            fetchNextPage();
        }
    }, [inView]);

    const debouncedChangeHandler = useCallback(
        debounce((event) => {
            setDecouncedSearchValue(event.target.value?.trim());
        }, 500),
        []
    );

    const updateAssigToMutation = useMutation({
        mutationFn: async (body) => {
            return await fetchUpdateAssingTo({
                pk: body.pk,
                sk: body.sk,
                assignTo: body.assignTo
            })
        },
        onSuccess: (data, variables) => {

            if (!data) return

            queryClient.setQueryData(queryKey, (oldData => {
                if (oldData) {
                    for (let i = 0; i < oldData.pages.length; i++) {
                        let page = oldData.pages[i];
                        page.Items = page.Items.map((item) => {
                            if (item.pk === variables.pk && item.sk === variables.sk) {
                                item = { ...item, ...data }
                            }
                            return item;
                        });

                        oldData.pages[i] = page;
                    }
                }
                return oldData
            }));
        },
        onError: (err) => {
            console.log(err)
            // setError(err?.response?.data?.message || err.message)
        }
    })

    const columns = ['isInKanban', 'pk', 'sk', 'title', 'desc', 'prority', 'createdBy', 'assignTo', 'lane', 'createdAt', 'updatedAt'];


    return (
        <div>
            {/* <p className="title">Backlog</p>
            <p className="sub-title">Enhancement and Bugs</p> */}
            {/* {lastUpdatedAt} */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0rem 1rem 1rem 0rem', }}>
                <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', width: '100%', flexWrap: 'wrap', }}>
                    <input
                        style={{ fontSize: "1rem", minWidth: "250px", padding: "1rem", borderRadius: ".4rem", border: "1px solid var(--lighterGrey)", outline: "none" }}
                        type="text"
                        id={"search"}
                        placeholder="Ticket number ..."
                        // list="items"
                        autoComplete="off"
                        // onFocus={() => setCurrentPage(0)}
                        onChange={(e) => {
                            setSearchValue(e.target.value);
                            debouncedChangeHandler(e);
                        }}
                        value={searchValue}
                    />
                </div>
            </div>


            {status === "loading" ? (
                <p>Loading...</p>
            ) : status === "error" ? (
                <span className='danger'>Error: {error.message}</span>
            ) : (
                <>
                    <SharedTable
                        type={"ticket"}
                        columns={columns}
                        items={data?.pages.flat()}
                        activeDraftId={null}
                        hasNextPage={hasNextPage}
                        isFetchingNextPage={isFetchingNextPage}
                        fetchNextPage={fetchNextPage}
                        isFetching={isFetching}
                        isLoading={isLoading}
                        queryKey={queryKey}
                        updateAssigToMutation={updateAssigToMutation}
                        //  onEditHandler={mutation}
                        // onDetailHandler={onDetailHandler}
                        ref={ref}
                    />
                </>
            )}


        </div>
    )
}

export default Backlog


// {resutls && <ReactJson
//     style={{ padding: "1rem", }}
//     src={resutls || ""}
//     name={false}
//     collapsed={1}
//     collapseStringsAfterLength={150}
//     displayDataTypes={false}
//     displayObjectSize={false}
//     sortKeys={false}
// />}